// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   GLOBAL RESET
========================= */

/* * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont,
      "Segoe UI", sans-serif;
    background: linear-gradient(135deg, #0f172a, #020617);
    color: #ffffff;
  } */

/* IMAGE UPLOAD STYLE */


/* .profile-label {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ccc;
    transition: 0.3s;
  }
  
  .profile-label:hover {
    border-color: #1877f2;
  }
  
  .profile-overlay {
    position: absolute;
    inset: 0;
    background: rgba(24, 119, 242, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: 0.3s;
  }
  
  .profile-label:hover .profile-overlay {
    opacity: 1;
  }
  
  .plus-icon {
    color: white;
    font-size: 42px;
    font-weight: bold;
    line-height: 1;
  }
  
  .profile-label img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .profile-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #777;
    gap: 6px;
    z-index: 1;
  }
   */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: #fff;
  padding: 30px;
  border-radius: 14px;
  width: 90%;
  max-width: 420px;
  text-align: center;
  animation: pop 0.3s ease;
}

.modal-card h2 {
  margin-bottom: 10px;
}

.modal-card p {
  margin-bottom: 20px;
  color: #555;
}

@keyframes pop {
  from {
    transform: scale(0.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}


/* Error message */

.input-wrapper {
  display: flex;
  flex-direction: column;
}

.input-error {
  border: 1.5px solid #ef4444;
  background: #fff5f5;
}

.error-message {
  margin-top: 6px;
  font-size: 13px;
  color: #dc2626;
  display: flex;
  align-items: center;
  gap: 6px;
}

.error-icon {
  font-weight: bold;
  font-size: 14px;
}





/* =========================
     CONTAINER
  ========================= */

.register-container {
  /* min-height: 100vh; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  margin-bottom: 50px;
}

.register-logo {
  /* display: block;
    margin: 0 auto;
    margin-top: 30px; */
}

/* =========================
     CARD
  ========================= */

.register-card {
  width: 100%;
  max-width: 600px;
  background-color: #1e293b;
  border-radius: 20px;
  padding: 30px 28px 35px;
  box-shadow: 0 10px 40px -20px rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(148, 163, 184, 0.12);
}

/* =========================
     TITLES
  ========================= */

.register-step animate h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 15px;
  text-align: center;
  letter-spacing: 0.3px;
}


.flexed_logo_title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.register-step h2 {
  font-size: 20px;
}

/* =========================
     PROGRESS BAR
  ========================= */

.register-progress {
  width: 100%;
  height: 6px;
  background: #1e293b;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 25px;
}

.register-progress-bar {
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #38bdf8, #22c55e);
  transition: width 0.4s ease;
}

/* =========================
     STEP ANIMATION
  ========================= */

.register-step {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.register-animate {
  animation: slideFade 0.45s ease;
}

@keyframes slideFade {
  from {
    opacity: 0;
    transform: translateX(35px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* =========================
     PROFILE GRID
  ========================= */

.register-profile-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.register-profile-grid button {
  padding: 14px 12px;
  border-radius: 14px;
  background: transparent;
  border: 1px solid #334155;
  color: #e5e7eb;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.25s ease;
}

.register-profile-grid button:hover {
  border-color: #38bdf8;
  background: rgba(56, 189, 248, 0.08);
}

.register-profile-grid button.active {
  /* background: linear-gradient(135deg, var(--bg-200), var(--bg-300) ); */
  background-color: var(--primary-100);
  color: #020617;
  font-weight: 700;
  border-color: transparent;
}

/* =========================
     FORM GRID
  ========================= */

.register-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

/* =========================
     INPUTS & SELECTS
  ========================= */


.register-inputs[type="date"] {
  width: 100%;
  height: 50px;
  min-height: 50px;
  font-size: 16px;
  padding: 0 12px;
  box-sizing: border-box;
  appearance: none;
}

.register-inputs,
.register-select {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #334155;
  background: #020617;
  color: #f8fafc;
  font-size: 16px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.register-inputs::placeholder {
  color: #94a3b8;
}

.register-select {
  cursor: pointer;
}

.register-inputs:focus,
.register-select:focus {
  outline: none;
  border-color: #38bdf8;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25);
}

/* full width for single inputs if needed */
.form-grid>*:only-child {
  grid-column: span 2;
}

/* =========================
     ACTION BUTTONS
  ========================= */

.register-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  gap: 12px;
}

.register-primary-btn {
  padding: 12px 22px;
  border-radius: 14px;
  /* background: linear-gradient(135deg, var(--primary-100), var(--primary-200) ); */
  background-color: var(--primary-200);
  border: none;
  font-weight: 700;
  color: var(--primary-300);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.register-primary-btn:hover {
  /* transform: translateY(-1px); */
  background-color: #6c95b7;
  transition: 0.3s;
  /* box-shadow: 6px -6px 50px -10px var(--accent-100); */
}

.register-primary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.register-secondary-btn {
  padding: 12px 22px;
  border-radius: 14px;
  background: transparent;
  border: 1px solid #334155;
  color: #e5e7eb;
  cursor: pointer;
  transition: background 0.25s ease, border-color 0.25s ease;
}

.register-secondary-btn:hover {
  background: rgba(148, 163, 184, 0.1);
  border-color: #38bdf8;
}

.register-step a {
  color: var(--primary-100);
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

/* =========================
     RESPONSIVE
  ========================= */

@media (max-width: 520px) {
  .register-card {
    padding: 24px 20px;
  }

  .register-form-grid {
    grid-template-columns: 1fr;
  }

  .register-profile-grid {
    grid-template-columns: 1fr;
  }

  .register-actions {
    flex-direction: column-reverse;
  }

  .register-primary-btn,
  .register-secondary-btn {
    width: 100%;
    text-align: center;
  }
}


.register-step h2 {
  color: var(--primary-300);
}


.register-topbar {
  width: 100%;
  max-width: 520px;
  /* même largeur que la carte */
  margin: 40px auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* logo */
.register-logo {
  /* width:160px; */
}

/* back button */
.register-back-home {
  font-size: 14px;
  color: #1c7ab4;
  text-decoration: none;
  display: flex;
  /* align-items:center; */
  /* gap:6px; */
  font-weight: 500;
  transition: .3s;
  margin-top: 40px;
}

.register-back-home:hover {
  color: #f35a0e;
  transform: translateX(-3px);
}


@media (max-width: 600px) {

  .register-topbar {
    max-width: 80%;
    padding: 0 20px;
    margin: 20px auto 10px;
  }

  .register-logo {
    width: 120px;
  }

  .register-back-home {
    font-size: 13px;
  }
}


.loading-hint {
  display: flex;
  align-items: center;
  gap: 8px;

  margin: 6px 0 10px;
  padding: 8px 12px;

  font-size: 0.85rem;
  font-weight: 500;

  color: #475569;
  /* slate-600 */
  background-color: #f8fafc;
  /* slate-50 */
  border-left: 3px solid var(--primary-100);
  /* blue-500 */

  border-radius: 6px;
}


.pdf-upload-label {
  height: 55px;
  border: 2px dashed var(--primary-200);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-weight: 600;
  transition: .25s;
}

.pdf-upload-label:hover {
  background: var(--bg-100);
  color: #020617;
}

.pdf-selected {
  margin-top: 8px;
  font-size: 13px;
  color: var(--primary-200);
  font-weight: 600;
}



.register-question {
  color: white;
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
}

.register-choice-row {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.choice-btn {
  border: none;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  background: #1b2f46;
  color: white;
  transition: .25s;
}

.choice-btn.active {
  background: var(--primary-100);
  transform: scale(1.04);
}



.verification-info-card {
  background: rgba(255, 255, 255, .06);
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 18px;
  padding: 22px;
  margin-bottom: 25px;
  color: white;
  backdrop-filter: blur(14px);
}

.verification-badge {
  display: inline-block;
  background: rgba(34, 197, 94, .18);
  color: #22c55e;
  padding: 6px 12px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 14px;
}

.verification-info-card h3 {
  margin-bottom: 10px;
  font-size: 18px;
}

.verification-info-card p {
  color: #cbd5e1;
  line-height: 1.6;
}

.verification-privacy {
  margin-top: 10px;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
}


.verification-wrapper {
  width: 100%;
}

.verification-content {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.verification-info-card {
  width: 100%;
}

.full-width {
  width: 100%;
}

.register-question {
  width: 100%;
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 10px;
}

.register-choice-row {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
}

.verification-privacy {
  margin-top: 30px;
}


.multi-status-block {
  grid-column: 1/-1;
}

.multi-status-title {
  display: block;
  margin-bottom: 16px;
  color: white;
  font-weight: 700;
  font-size: 18px;
}

.status-chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.status-chip {
  border: none;
  cursor: pointer;
  padding: 12px 18px;
  border-radius: 999px;
  background: #0f172a;
  color: white;
  border: 1px solid rgba(255, 255, 255, .1);
  transition: .2s;
}

.status-chip:hover {
  transform: translateY(-2px);
}

.status-chip.active {
  background: var(--primary-200);
  color: white;
}

.status-chip:disabled {
  opacity: .35;
  cursor: not-allowed;
}


.input-success {
  border: 1px solid #00c853;
}

.password-rules {
  margin-top: 8px;
  font-size: 13px;
}

.ok {
  color: #00c853;
}

.bad {
  color: #ff3b30;
}


/* sszdsz.. */
.password-strength-bar {
  width: 100%;
  height: 6px;
  background: #eee;
  border-radius: 50px;
  margin-top: 8px;
  overflow: hidden;
}

.password-strength-bar span {
  display: block;
  height: 100%;
  transition: .3s;
}

.weak {
  background: #ff3b30;
}

.medium {
  background: #ff9500;
}

.strong {
  background: #00c853;
}

.password-message {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #d0d0d0;
}



/* reset password */

.forgot-modal {

  width: 350px;

  padding: 35px;

  border-radius: 24px;

  background: white;

  display: flex;
  flex-direction: column;

  align-items: center;

  gap: 18px;

  animation: fadeUp .35s ease;

}

.forgot-icon {

  width: 70px;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  font-size: 32px;

  background:
    linear-gradient(135deg,
      #eff6ff,
      #dbeafe);

  margin-bottom: 5px;

}

.forgot-subtitle {

  font-size: 14px;

  color: #64748b;

  text-align: center;

  line-height: 1.6;

  margin-bottom: 10px;

}

.forgot-input {

  width: 100%;

  padding: 14px 18px;

  border-radius: 14px;

  border:
    1px solid #e2e8f0;

  outline: none;

  font-size: 14px;

  transition: .3s;

}

.forgot-input:focus {

  border-color: var(--primary-100);

  box-shadow:
    0 0 0 4px rgba(255, 155, 92, 0.1);

}

.forgot-btn {

  width: 100%;

  padding: 14px;

  border: none;

  border-radius: 14px;

  background: var(--primary-100);

  color: white;

  font-size: 15px;

  font-weight: 600;

  cursor: pointer;

  transition: .3s;

}

.forgot-btn:hover {

  transform:
    translateY(-2px);

}

@keyframes fadeUp {

  from {

    opacity: 0;

    transform:
      translateY(20px);

  }

  to {

    opacity: 1;

    transform:
      translateY(0);

  }

}


.password-input-container {
  position: relative;
  width: 100%;
}

.password-input-container input {
  width: 100%;
  padding-right: 45px;
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #777;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.password-toggle:hover {
  color: #333;
}

/* Register — premium CarrerUp high-tech shell */
.register-page {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  min-height: 100svh;
  justify-content: flex-start;
  overflow: visible;
  color: #17344f;
  background-color: #edf4f8;
  padding: 18px 20px 42px;
}

.register-topbar { width: min(1040px, 100%); margin: 0 auto 18px; display: flex; }
.register-back-home { display: inline-flex; align-items: center; min-height: 42px; padding: 0 16px; border: 1px solid #d6e4ee; border-radius: 12px; background: #fff; color: #4e7799; font-weight: 800; text-decoration: none; box-shadow: 0 8px 22px rgba(41,74,101,.08); }
.register-container { min-height: auto; margin: 0; padding: 0; align-items: flex-start; }
.register-card { position: relative; width: min(100%, 900px); max-width: 900px; padding: 34px; overflow: hidden; border: 1px solid #d8e5ed; border-radius: 24px; background: #fff; box-shadow: 0 26px 60px rgba(33,63,88,.14); }
.register-card::before { content: ""; position: absolute; inset: 0 auto 0 0; width: 5px; background: #e95a13; }
.register-step { position: relative; gap: 18px; }
.register-step h2 { margin: 2px 0 4px; color: #17344f; font-size: clamp(1.3rem, 2vw, 1.8rem); font-weight: 850; letter-spacing: -.035em; }
.flexed_logo_title { padding-bottom: 8px; border-bottom: 1px solid #e4edf2; }
.flexed_logo_title img { width: 44px !important; height: 44px; padding: 7px; object-fit: contain; border: 1px solid #f4c4aa; border-radius: 13px; background: #fff6f1; }
.register-journey { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin: 0 0 28px; padding: 13px; border: 1px solid #dbe7ee; border-radius: 16px; background: #f7fafc; }
.register-journey-step { display: flex; align-items: center; gap: 9px; color: #94a9ba; font-weight: 800; }
.register-journey-step span { display: grid; width: 29px; height: 29px; place-items: center; border: 1px solid #c6d7e2; border-radius: 9px; background: #fff; font-size: .8rem; }
.register-journey-step small { font-size: .72rem; text-transform: uppercase; letter-spacing: .08em; }
.register-journey-step.is-active { color: #4e7799; }.register-journey-step.is-active span { border-color: #4e7799; }.register-journey-step.is-current { color: #e95a13; }.register-journey-step.is-current span { border-color: #e95a13; background: #fff4ee; }
.register-profile-grid { grid-template-columns: repeat(3, 1fr); gap: 12px; }
.register-profile-grid button { min-height: 84px; padding: 14px; border: 1px solid #d9e6ee; border-radius: 15px; background: #fff; color: #315978; font-weight: 800; box-shadow: none; transition: transform .18s ease, border-color .18s ease, background .18s ease; }
.register-profile-grid button:hover { transform: translateY(-2px); border-color: #94a9ba; }.register-profile-grid button.active { border-color: #e95a13; background: #fff5f0; color: #c74608; box-shadow: inset 0 0 0 1px #e95a13; }
.register-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 14px; }.register-form-grid .full-width, .register-form-grid .status-container, .register-form-grid .loading-hint { grid-column: 1 / -1; }
.register-inputs, .register-select { box-sizing: border-box; width: 100%; min-height: 48px; padding: 0 14px; border: 1px solid #d4e2eb; border-radius: 12px; background: #fbfdfe; color: #17344f; outline: none; box-shadow: none; }
.register-inputs:focus, .register-select:focus { border-color: #4e7799; background: #fff; box-shadow: 0 0 0 3px rgba(78,119,153,.12); }.register-inputs::placeholder { color: #94a9ba; }
.register-actions { display: grid; grid-template-columns: 1fr 1.35fr; gap: 12px; margin-top: 8px; }.register-primary-btn, .register-secondary-btn { min-height: 48px; border-radius: 12px; font-weight: 850; }.register-primary-btn { border: 1px solid #e95a13; background: #e95a13; color: #fff; box-shadow: 0 9px 18px rgba(233,90,19,.2); }.register-secondary-btn { border: 1px solid #d2e0e9; background: #fff; color: #4e7799; }
.verification-wrapper { display: grid; gap: 14px; }.verification-info-card, .verification-content, .verification-privacy { border: 1px solid #dbe7ee; border-radius: 16px; background: #f8fbfd; }.verification-info-card { padding: 19px; }.verification-info-card h3 { margin: 9px 0 5px; color: #17344f; }.verification-info-card p, .verification-privacy { color: #66839a; }.verification-content { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; padding: 14px; }.pdf-upload-label { display:flex; align-items:center; min-height: 58px; padding: 12px 14px; border: 1px dashed #94a9ba; border-radius: 12px; background:#fff; color:#315978; font-weight:800; cursor:pointer; }.pdf-upload-label:hover { border-color:#e95a13; color:#e95a13; }.pdf-selected { margin-top: 7px; color:#4e7799; font-size:.82rem; font-weight:700; }.verification-privacy { padding: 13px 16px; font-size: .84rem; }
@media (max-width: 640px) { .register-page { padding: 12px 12px 28px; }.register-topbar { margin-bottom: 12px; }.register-card { padding: 22px 17px; border-radius: 18px; }.register-journey { padding: 10px; gap: 5px; }.register-journey-step { justify-content:center; }.register-journey-step small { display:none; }.register-profile-grid, .register-form-grid, .verification-content { grid-template-columns: 1fr; }.register-profile-grid button { min-height: 58px; }.register-actions { grid-template-columns: 1fr; }.register-actions .register-secondary-btn { order: 2; }.register-step > a { text-align:center; }.flexed_logo_title { gap: 8px; } }

/* Registration mobile experience */
.register-card { animation: registerCardArrive .56s cubic-bezier(.2,.9,.25,1) both; }
.register-animate { animation: registerStepReveal .42s cubic-bezier(.2,.9,.25,1) both; }
.register-journey-step.is-current span { animation: registerStepPulse 1.8s ease-in-out infinite; }
.register-profile-grid button { animation: registerOptionReveal .38s ease both; }
.register-profile-grid button:nth-child(2) { animation-delay:.04s; }.register-profile-grid button:nth-child(3) { animation-delay:.08s; }.register-profile-grid button:nth-child(4) { animation-delay:.12s; }.register-profile-grid button:nth-child(5) { animation-delay:.16s; }.register-profile-grid button:nth-child(6) { animation-delay:.20s; }.register-profile-grid button:nth-child(7) { animation-delay:.24s; }
.register-primary-btn:not(:disabled):active, .register-secondary-btn:active { transform:scale(.98); }
@keyframes registerCardArrive { from { opacity:0; transform:translateY(22px) scale(.985); } to { opacity:1; transform:translateY(0) scale(1); } }
@keyframes registerStepReveal { from { opacity:0; transform:translateX(18px); } to { opacity:1; transform:translateX(0); } }
@keyframes registerOptionReveal { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
@keyframes registerStepPulse { 0%,100% { box-shadow:0 0 0 0 rgba(233,90,19,.22); } 50% { box-shadow:0 0 0 7px rgba(233,90,19,0); } }

@media (max-width: 640px) {
  .register-page { min-height:100svh; padding:10px 10px 22px; }
  .register-topbar { position:relative; top:auto; z-index:auto; max-width:100%; padding:0; margin:0 0 10px; }.register-back-home { min-height:38px; margin:0; padding:0 13px; border-radius:11px; font-size:.79rem; }
  .register-card { width:100%; padding:18px 14px 20px; border-radius:17px; box-shadow:0 16px 34px rgba(33,63,88,.13); }.register-card::before { width:3px; }
  .register-journey { margin-bottom:18px; padding:8px; border-radius:13px; }.register-journey-step span { width:27px; height:27px; border-radius:8px; }
  .register-step { gap:14px; }.register-step h2 { font-size:1.28rem; line-height:1.16; }.flexed_logo_title { padding-bottom:10px; }.flexed_logo_title img { width:39px !important; height:39px; border-radius:11px; }
  .register-profile-grid { grid-template-columns:repeat(2,minmax(0,1fr)); gap:9px; }.register-profile-grid button { min-height:70px; padding:10px 7px; border-radius:13px; font-size:.79rem; line-height:1.15; }.register-profile-grid button:last-child:nth-child(odd) { grid-column:1 / -1; }
  .register-form-grid { gap:11px; }.register-inputs, .register-select { min-height:52px; padding:0 13px; border-radius:11px; font-size:16px; }.input-wrapper { gap:3px; }.password-strength-bar { margin-top:4px; }.password-message { margin-top:3px; line-height:1.35; }
  .register-actions { position:sticky; bottom:8px; z-index:3; gap:8px; margin:8px -2px -2px; padding:10px 2px 2px; background:#fff; }.register-primary-btn, .register-secondary-btn { min-height:51px; border-radius:12px; }
  .verification-info-card { padding:15px; border-radius:14px; }.verification-info-card h3 { font-size:1rem; }.verification-info-card p { font-size:.82rem; line-height:1.5; }.verification-content { padding:10px; gap:9px; border-radius:14px; }.pdf-upload-label { min-height:54px; padding:10px 12px; font-size:.82rem; }.verification-privacy { padding:11px 13px; font-size:.76rem; }
}

@media (max-width: 360px) { .register-page { padding:8px; }.register-card { padding:16px 11px; }.register-profile-grid { gap:7px; }.register-profile-grid button { min-height:63px; font-size:.73rem; }.register-step h2 { font-size:1.16rem; }.register-journey { margin-bottom:14px; }.register-actions { bottom:4px; } }
@media (prefers-reduced-motion: reduce) { .register-card, .register-animate, .register-profile-grid button, .register-journey-step.is-current span, .verification-upload-alert, .verification-upload-alert > span, .verification-upload-error .pdf-upload-label, .verification-upload-error .pdf-upload-label::before { animation:none; } }

@media (max-width: 640px) {
  .register-step--form { gap:11px; }.register-step--form h2 { margin:0 2px 1px; font-size:1.2rem; }.register-step--form .register-form-grid { position:relative; max-height:min(48svh, 440px); overflow-y:auto; overscroll-behavior:contain; padding:10px; border:1px solid #dbe8ef; border-radius:16px; background:#f7fafc; gap:7px; box-shadow:inset 0 1px 0 #fff; scrollbar-width:thin; scrollbar-color:#94a9ba transparent; }.register-step--form .register-form-grid::-webkit-scrollbar { width:5px; }.register-step--form .register-form-grid::-webkit-scrollbar-thumb { border-radius:999px; background:#94a9ba; }.register-step--form .register-form-grid::before { content:"INFORMATIONS DU PROFIL"; grid-column:1 / -1; margin:0 2px 3px; color:#4e7799; font-size:.62rem; font-weight:900; letter-spacing:.13em; }
  .register-step--form .register-actions { position:relative; bottom:auto; margin:2px 0 0; padding:0; background:transparent; }.register-step--form .register-inputs, .register-step--form .register-select { min-height:43px; padding:0 11px; border-radius:10px; background:#fff; border-color:#d7e5ed; font-size:.85rem; }.register-step--form .input-wrapper:focus-within { transform:translateY(-1px); transition:transform .18s ease; }
.register-step--form .error-message { padding:4px 7px; border:1px solid #f2c7bd; border-radius:7px; background:#fff6f3; font-size:.68rem; }.register-step--form .loading-hint { padding:8px 10px; border:1px solid #d8e6ee; border-radius:9px; background:#f7fbfd; color:#4e7799; font-size:.75rem; font-weight:750; }
.register-date-label { display:block;margin:0 0 6px 3px;color:#4e7799;font-size:.72rem;font-weight:850;letter-spacing:.02em; }
.register-date-label::before { content:"";display:inline-block;width:5px;height:5px;margin-right:7px;border-radius:50%;background:#e95a13;box-shadow:0 0 7px rgba(233,90,19,.5);vertical-align:middle; }
  .register-step--verification { gap:9px; }
  .register-step--verification h2 { margin:0; padding:0 3px; }
  .register-step--verification .verification-wrapper {
    max-height:none;
    overflow:visible;
    padding:0;
    gap:8px;
  }
  .register-step--verification .verification-content { order:1; }
  .register-step--verification .verification-info-card { order:2; }
  .register-step--verification .verification-privacy { order:3; }
  .register-step--verification .verification-info-card {
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    gap:5px;
    padding:12px 13px;
    border-color:#d5e3eb;
    background:linear-gradient(145deg,#fff,#f7fafc);
    box-shadow:0 7px 18px rgba(31,67,94,.055);
  }
  .register-step--verification .verification-badge { display:inline-flex; align-items:center; width:auto; max-width:100%; padding:5px 8px; border:1px solid #f0c0a5; border-radius:8px; background:#fff5f0; color:#ca4c0a; font-size:.64rem; font-weight:850; line-height:1.2; }
  .register-step--verification .verification-info-card h3 { margin:1px 0 0; font-size:.94rem; line-height:1.22; }
  .register-step--verification .verification-info-card p { margin:0; color:#66839a; font-size:.75rem; line-height:1.42; }
  .register-step--verification .verification-content { position:relative; overflow:visible; padding:11px; gap:8px; border-color:#d5e3eb; background:#f8fbfd; }.register-step--verification .verification-content::before { content:"DOCUMENTS REQUIS"; display:block; grid-column:1 / -1; margin:0 2px 2px; color:#4e7799; font-size:.61rem; font-weight:900; letter-spacing:.12em; }
  .register-step--verification .pdf-upload-label { position:relative; justify-content:flex-start; min-height:52px; padding:9px 11px 9px 42px; border-color:#aac0cf; line-height:1.3; }.register-step--verification .pdf-upload-label::before { content:"+"; position:absolute; left:12px; display:grid; width:22px; height:22px; place-items:center; border:1px solid #f0b18c; border-radius:7px; background:#fff4ee; color:#e95a13; font-size:1rem; line-height:1; }
.register-step--verification .pdf-selected { padding:7px 9px; border:1px solid #d8e7ee; border-radius:8px; background:#fff; font-size:.74rem; overflow-wrap:anywhere; }.register-step--verification .register-question { color:#315978; font-size:.88rem; font-weight:800; }.register-step--verification .register-choice-row { display:grid; grid-template-columns:1fr 1fr; gap:8px; }.register-step--verification .choice-btn { min-height:46px; border-radius:11px; }
.register-step--verification .verification-privacy { margin:0; padding:9px 11px; border-color:#d8e5ed; background:#f8fbfd; font-size:.72rem; line-height:1.4; }
.register-step--verification .register-actions { position:relative; bottom:auto; grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr); gap:7px; margin:1px 0 0; padding:0; background:transparent; }
.register-step--verification .register-actions .register-secondary-btn { order:initial; }
.register-step--verification .register-primary-btn, .register-step--verification .register-secondary-btn { min-height:47px; padding:7px 8px; font-size:.78rem; }
.register-step--verification .register-primary-btn { box-shadow:0 9px 18px rgba(233,90,19,.22); }

.verification-upload-alert {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
  box-sizing: border-box;
  margin: 2px 0;
  padding: 12px 14px;
  border: 1px solid #ef9c72;
  border-radius: 12px;
  color: #8f340c;
  background: #fff3ed;
  box-shadow: 0 10px 24px rgba(233, 90, 19, .12);
  animation: verificationAlertIn .38s cubic-bezier(.2, .9, .25, 1) both;
}
.verification-upload-alert > span {
  display: grid;
  flex: 0 0 25px;
  width: 25px;
  height: 25px;
  place-items: center;
  border-radius: 8px;
  color: #fff;
  background: #e95a13;
  font-weight: 900;
  animation: verificationAlertPulse 1.15s ease-in-out 2;
}
.verification-upload-alert strong { display: block; font-size: .82rem; }
.verification-upload-alert p { margin: 3px 0 0; font-size: .74rem; line-height: 1.4; }
.verification-upload-error .pdf-upload-label {
  border-color: #e95a13;
  color: #c74608;
  background: #fff8f4;
  animation: verificationUploadShake .48s cubic-bezier(.36, .07, .19, .97) both;
}
.verification-upload-error .pdf-upload-label::before {
  color: #fff;
  background: #e95a13;
  box-shadow: 0 0 0 5px rgba(233, 90, 19, .11);
  animation: verificationUploadPulse 1.2s ease-in-out infinite;
}
@media (min-width: 641px) {
  .verification-upload-alert {
    gap: 14px;
    padding: 15px 17px;
    border-radius: 14px;
    box-shadow: 0 14px 32px rgba(233, 90, 19, .14);
  }
  .verification-upload-alert > span {
    flex-basis: 30px;
    width: 30px;
    height: 30px;
    border-radius: 9px;
    font-size: 1rem;
  }
  .verification-upload-alert strong { font-size: .92rem; }
  .verification-upload-alert p { margin-top: 4px; font-size: .82rem; }
  .verification-upload-error .verification-content {
    border-color: rgba(233, 90, 19, .48);
    background: #fffaf7;
    box-shadow: 0 0 0 3px rgba(233, 90, 19, .07);
    transition: border-color .2s ease, background .2s ease, box-shadow .2s ease;
  }
}
@keyframes verificationAlertIn {
  from { opacity: 0; transform: translateY(-8px) scale(.98); }
  to { opacity: 1; transform: none; }
}
@keyframes verificationAlertPulse { 50% { transform: scale(1.12); box-shadow: 0 0 0 7px rgba(233,90,19,.12); } }
@keyframes verificationUploadPulse { 50% { transform: scale(1.1); box-shadow: 0 0 0 8px rgba(233,90,19,.05); } }
@keyframes verificationUploadShake {
  20%, 60% { transform: translateX(-5px); }
  40%, 80% { transform: translateX(5px); }
}
}

@media (min-width: 430px) and (max-width: 640px) {
  .register-step--form .register-form-grid { grid-template-columns:repeat(2, minmax(0, 1fr)); gap:9px; padding:12px; }.register-step--form .register-form-grid .full-width, .register-step--form .register-form-grid .status-container, .register-step--form .register-form-grid .loading-hint { grid-column:1 / -1; }.register-step--form .register-actions { grid-template-columns:1fr 1.35fr; }.register-step--form .register-actions .register-secondary-btn { order:initial; }
}
`, "",{"version":3,"sources":["webpack://./src/auth/Register.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;;;;;;;;;;;KAWK;;AAEL,uBAAuB;;;AAGvB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAwDI;;AAEJ;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;;AAGA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;;;;;AAMA;;6BAE6B;;AAE7B;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;;uBAEqB;AACvB;;AAEA;;6BAE6B;;AAE7B;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA;;6BAE6B;;AAE7B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;6BAE6B;;AAE7B;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;;6BAE6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;6BAE6B;;AAE7B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;6BAE6B;;AAE7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;6BAE6B;;;AAG7B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;AACrB;;AAEA;;6BAE6B;;AAE7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kFAAkF;EAClF,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;6BAE6B;;AAE7B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;AACF;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;;AAGA;;EAEE;IACE,cAAc;IACd,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,kBAAkB;EAClB,iBAAiB;;EAEjB,kBAAkB;EAClB,gBAAgB;;EAEhB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,aAAa;;EAEb,kBAAkB;AACpB;;;AAGA;EACE,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;;;AAIA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;;;AAIA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA,aAAa;AACb;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;;;AAIA,mBAAmB;;AAEnB;;EAEE,YAAY;;EAEZ,aAAa;;EAEb,mBAAmB;;EAEnB,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;;EAEnB,SAAS;;EAET,2BAA2B;;AAE7B;;AAEA;;EAEE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,eAAe;;EAEf;;;cAGY;;EAEZ,kBAAkB;;AAEpB;;AAEA;;EAEE,eAAe;;EAEf,cAAc;;EAEd,kBAAkB;;EAElB,gBAAgB;;EAEhB,mBAAmB;;AAErB;;AAEA;;EAEE,WAAW;;EAEX,kBAAkB;;EAElB,mBAAmB;;EAEnB;qBACmB;;EAEnB,aAAa;;EAEb,eAAe;;EAEf,eAAe;;AAEjB;;AAEA;;EAEE,gCAAgC;;EAEhC;qCACmC;;AAErC;;AAEA;;EAEE,WAAW;;EAEX,aAAa;;EAEb,YAAY;;EAEZ,mBAAmB;;EAEnB,8BAA8B;;EAE9B,YAAY;;EAEZ,eAAe;;EAEf,gBAAgB;;EAEhB,eAAe;;EAEf,eAAe;;AAEjB;;AAEA;;EAEE;oBACkB;;AAEpB;;AAEA;;EAEE;;IAEE,UAAU;;IAEV;sBACkB;;EAEpB;;EAEA;;IAEE,UAAU;;IAEV;mBACe;;EAEjB;;AAEF;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,mBAAmB,wBAAwB,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACjF,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,0CAA0C,EAAE;AAC3Q,sBAAsB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,uBAAuB,EAAE;AACxF,iBAAiB,kBAAkB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,aAAa,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,0CAA0C,EAAE;AAC/N,yBAAyB,WAAW,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAC9G,iBAAiB,kBAAkB,EAAE,SAAS,EAAE;AAChD,oBAAoB,iBAAiB,EAAE,cAAc,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACzI,qBAAqB,mBAAmB,EAAE,gCAAgC,EAAE;AAC5E,yBAAyB,sBAAsB,EAAE,YAAY,EAAE,YAAY,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACvK,oBAAoB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,gBAAgB,EAAE,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC3L,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACzG,8BAA8B,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAChL,+BAA+B,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACpG,mCAAmC,cAAc,EAAE,CAAC,wCAAwC,qBAAqB,EAAE,CAAC,oCAAoC,cAAc,EAAE,CAAC,yCAAyC,qBAAqB,EAAE,mBAAmB,EAAE;AAC9P,yBAAyB,qCAAqC,EAAE,SAAS,EAAE;AAC3E,gCAAgC,gBAAgB,EAAE,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,6EAA6E,EAAE;AACtQ,sCAAsC,2BAA2B,EAAE,qBAAqB,EAAE,CAAC,uCAAuC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE,mCAAmC,EAAE;AACnO,sBAAsB,aAAa,EAAE,+CAA+C,EAAE,SAAS,EAAE,CAAC,4GAA4G,mBAAmB,EAAE;AACnO,qCAAqC,sBAAsB,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE;AACnO,iDAAiD,qBAAqB,EAAE,gBAAgB,EAAE,0CAA0C,EAAE,CAAC,gCAAgC,cAAc,EAAE;AACvL,oBAAoB,aAAa,EAAE,iCAAiC,EAAE,SAAS,EAAE,eAAe,EAAE,CAAC,iDAAiD,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,CAAC,wBAAwB,yBAAyB,EAAE,mBAAmB,EAAE,WAAW,EAAE,yCAAyC,EAAE,CAAC,0BAA0B,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACta,wBAAwB,aAAa,EAAE,SAAS,EAAE,CAAC,wEAAwE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,CAAC,0BAA0B,aAAa,EAAE,CAAC,6BAA6B,iBAAiB,EAAE,cAAc,EAAE,CAAC,mDAAmD,cAAc,EAAE,CAAC,wBAAwB,aAAa,EAAE,8CAA8C,EAAE,SAAS,EAAE,aAAa,EAAE,CAAC,oBAAoB,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE,eAAe,EAAE,aAAa,EAAE,eAAe,EAAE,cAAc,EAAE,CAAC,0BAA0B,oBAAoB,EAAE,aAAa,EAAE,CAAC,gBAAgB,eAAe,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE,CAAC,wBAAwB,kBAAkB,EAAE,iBAAiB,EAAE;AACp4B,4BAA4B,iBAAiB,uBAAuB,EAAE,CAAC,mBAAmB,mBAAmB,EAAE,CAAC,iBAAiB,kBAAkB,EAAE,mBAAmB,EAAE,CAAC,oBAAoB,aAAa,EAAE,QAAQ,EAAE,CAAC,yBAAyB,sBAAsB,EAAE,CAAC,+BAA+B,YAAY,EAAE,CAAC,qEAAqE,0BAA0B,EAAE,CAAC,gCAAgC,gBAAgB,EAAE,CAAC,oBAAoB,0BAA0B,EAAE,CAAC,4CAA4C,QAAQ,EAAE,CAAC,qBAAqB,iBAAiB,EAAE,CAAC,qBAAqB,QAAQ,EAAE,EAAE;;AAEhoB,mCAAmC;AACnC,iBAAiB,iEAAiE,EAAE;AACpF,oBAAoB,iEAAiE,EAAE;AACvF,yCAAyC,sDAAsD,EAAE;AACjG,gCAAgC,8CAA8C,EAAE;AAChF,6CAA6C,oBAAoB,EAAE,CAAC,6CAA6C,oBAAoB,EAAE,CAAC,6CAA6C,oBAAoB,EAAE,CAAC,6CAA6C,oBAAoB,EAAE,CAAC,6CAA6C,oBAAoB,EAAE,CAAC,6CAA6C,oBAAoB,EAAE;AACvZ,8EAA8E,oBAAoB,EAAE;AACpG,gCAAgC,OAAO,SAAS,EAAE,sCAAsC,EAAE,EAAE,KAAK,SAAS,EAAE,gCAAgC,EAAE,EAAE;AAChJ,gCAAgC,OAAO,SAAS,EAAE,0BAA0B,EAAE,EAAE,KAAK,SAAS,EAAE,uBAAuB,EAAE,EAAE;AAC3H,kCAAkC,OAAO,SAAS,EAAE,0BAA0B,EAAE,EAAE,KAAK,SAAS,EAAE,uBAAuB,EAAE,EAAE;AAC7H,+BAA+B,UAAU,sCAAsC,EAAE,EAAE,MAAM,sCAAsC,EAAE,EAAE;;AAEnI;EACE,iBAAiB,iBAAiB,EAAE,sBAAsB,EAAE;EAC5D,mBAAmB,iBAAiB,EAAE,QAAQ,EAAE,YAAY,EAAE,cAAc,EAAE,SAAS,EAAE,eAAe,EAAE,CAAC,sBAAsB,eAAe,EAAE,QAAQ,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EAClN,iBAAiB,UAAU,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,yCAAyC,EAAE,CAAC,yBAAyB,SAAS,EAAE;EACzJ,oBAAoB,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE,CAAC,8BAA8B,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE;EACpJ,iBAAiB,QAAQ,EAAE,CAAC,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,CAAC,qBAAqB,mBAAmB,EAAE,CAAC,yBAAyB,qBAAqB,EAAE,WAAW,EAAE,kBAAkB,EAAE;EAClN,yBAAyB,6CAA6C,EAAE,OAAO,EAAE,CAAC,gCAAgC,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,CAAC,0DAA0D,kBAAkB,EAAE;EAC5R,sBAAsB,QAAQ,EAAE,CAAC,qCAAqC,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE,cAAc,EAAE,CAAC,iBAAiB,OAAO,EAAE,CAAC,yBAAyB,cAAc,EAAE,CAAC,oBAAoB,cAAc,EAAE,gBAAgB,EAAE;EACvQ,oBAAoB,eAAe,EAAE,UAAU,EAAE,SAAS,EAAE,OAAO,EAAE,oBAAoB,EAAE,oBAAoB,EAAE,eAAe,EAAE,CAAC,iDAAiD,eAAe,EAAE,kBAAkB,EAAE;EACzN,0BAA0B,YAAY,EAAE,kBAAkB,EAAE,CAAC,6BAA6B,cAAc,EAAE,CAAC,4BAA4B,gBAAgB,EAAE,eAAe,EAAE,CAAC,wBAAwB,YAAY,EAAE,OAAO,EAAE,kBAAkB,EAAE,CAAC,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,CAAC,wBAAwB,iBAAiB,EAAE,gBAAgB,EAAE;AACzX;;AAEA,4BAA4B,iBAAiB,WAAW,EAAE,CAAC,iBAAiB,iBAAiB,EAAE,CAAC,yBAAyB,OAAO,EAAE,CAAC,gCAAgC,eAAe,EAAE,gBAAgB,EAAE,CAAC,oBAAoB,iBAAiB,EAAE,CAAC,oBAAoB,kBAAkB,EAAE,CAAC,oBAAoB,UAAU,EAAE,EAAE;AAC1T,0CAA0C,8QAA8Q,cAAc,EAAE,EAAE;;AAE1U;EACE,uBAAuB,QAAQ,EAAE,CAAC,0BAA0B,gBAAgB,EAAE,gBAAgB,EAAE,CAAC,2CAA2C,iBAAiB,EAAE,4BAA4B,EAAE,eAAe,EAAE,2BAA2B,EAAE,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,OAAO,EAAE,6BAA6B,EAAE,oBAAoB,EAAE,mCAAmC,EAAE,CAAC,8DAA8D,SAAS,EAAE,CAAC,oEAAoE,mBAAmB,EAAE,kBAAkB,EAAE,CAAC,mDAAmD,gCAAgC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB,EAAE;EAC1xB,yCAAyC,iBAAiB,EAAE,WAAW,EAAE,cAAc,EAAE,SAAS,EAAE,sBAAsB,EAAE,CAAC,+EAA+E,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,CAAC,mDAAmD,0BAA0B,EAAE,8BAA8B,EAAE;AAC5a,sCAAsC,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,CAAC,qCAAqC,gBAAgB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACrT,uBAAuB,aAAa,CAAC,kBAAkB,CAAC,aAAa,CAAC,gBAAgB,CAAC,eAAe,CAAC,oBAAoB,EAAE;AAC7H,+BAA+B,UAAU,CAAC,oBAAoB,CAAC,SAAS,CAAC,UAAU,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,qCAAqC,CAAC,qBAAqB,EAAE;EACrM,+BAA+B,OAAO,EAAE;EACxC,kCAAkC,QAAQ,EAAE,aAAa,EAAE;EAC3D;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,OAAO;EACT;EACA,qDAAqD,OAAO,EAAE;EAC9D,uDAAuD,OAAO,EAAE;EAChE,qDAAqD,OAAO,EAAE;EAC9D;IACE,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,OAAO;IACP,iBAAiB;IACjB,oBAAoB;IACpB,+CAA+C;IAC/C,yCAAyC;EAC3C;EACA,mDAAmD,mBAAmB,EAAE,kBAAkB,EAAE,UAAU,EAAE,cAAc,EAAE,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;EAC7Q,0DAA0D,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;EAC9G,yDAAyD,QAAQ,EAAE,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;EACtH,qDAAqD,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE,OAAO,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,CAAC,6DAA6D,0BAA0B,EAAE,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB,EAAE;EAClX,iDAAiD,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,eAAe,EAAE,CAAC,yDAAyD,WAAW,EAAE,iBAAiB,EAAE,SAAS,EAAE,YAAY,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,aAAa,EAAE;AACpc,6CAA6C,eAAe,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,CAAC,kDAAkD,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE,CAAC,oDAAoD,YAAY,EAAE,6BAA6B,EAAE,OAAO,EAAE,CAAC,2CAA2C,eAAe,EAAE,kBAAkB,EAAE;AACvc,qDAAqD,QAAQ,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC9J,iDAAiD,iBAAiB,EAAE,WAAW,EAAE,oDAAoD,EAAE,OAAO,EAAE,cAAc,EAAE,SAAS,EAAE,sBAAsB,EAAE;AACnM,yEAAyE,aAAa,EAAE;AACxF,2GAA2G,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/J,qDAAqD,yCAAyC,EAAE;;AAEhG;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,qEAAqE;AACvE;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;AACvD;AACA,oCAAoC,cAAc,EAAE,iBAAiB,EAAE;AACvE,+BAA+B,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACrF;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,6EAA6E;AAC/E;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,4DAA4D;AAC9D;AACA;EACE;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;EAChD;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA,oCAAoC,iBAAiB,EAAE;EACvD,+BAA+B,eAAe,EAAE,iBAAiB,EAAE;EACnE;IACE,oCAAoC;IACpC,mBAAmB;IACnB,4CAA4C;IAC5C,2EAA2E;EAC7E;AACF;AACA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;AACA,oCAAoC,MAAM,sBAAsB,EAAE,yCAAyC,EAAE,EAAE;AAC/G,qCAAqC,MAAM,qBAAqB,EAAE,yCAAyC,EAAE,EAAE;AAC/G;EACE,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;AACA;;AAEA;EACE,2CAA2C,+CAA+C,EAAE,OAAO,EAAE,YAAY,EAAE,CAAC,2KAA2K,kBAAkB,EAAE,CAAC,yCAAyC,gCAAgC,EAAE,CAAC,iEAAiE,aAAa,EAAE;AACld","sourcesContent":["/* =========================\n   GLOBAL RESET\n========================= */\n\n/* * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n  \n  body {\n    font-family: \"Inter\", system-ui, -apple-system, BlinkMacSystemFont,\n      \"Segoe UI\", sans-serif;\n    background: linear-gradient(135deg, #0f172a, #020617);\n    color: #ffffff;\n  } */\n\n/* IMAGE UPLOAD STYLE */\n\n\n/* .profile-label {\n    position: relative;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    cursor: pointer;\n    overflow: hidden;\n    background: #f0f2f5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px dashed #ccc;\n    transition: 0.3s;\n  }\n  \n  .profile-label:hover {\n    border-color: #1877f2;\n  }\n  \n  .profile-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(24, 119, 242, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: 0.3s;\n  }\n  \n  .profile-label:hover .profile-overlay {\n    opacity: 1;\n  }\n  \n  .plus-icon {\n    color: white;\n    font-size: 42px;\n    font-weight: bold;\n    line-height: 1;\n  }\n  \n  .profile-label img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .profile-placeholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 12px;\n    color: #777;\n    gap: 6px;\n    z-index: 1;\n  }\n   */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal-card {\n  background: #fff;\n  padding: 30px;\n  border-radius: 14px;\n  width: 90%;\n  max-width: 420px;\n  text-align: center;\n  animation: pop 0.3s ease;\n}\n\n.modal-card h2 {\n  margin-bottom: 10px;\n}\n\n.modal-card p {\n  margin-bottom: 20px;\n  color: #555;\n}\n\n@keyframes pop {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n\n/* Error message */\n\n.input-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.input-error {\n  border: 1.5px solid #ef4444;\n  background: #fff5f5;\n}\n\n.error-message {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.error-icon {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n\n\n\n\n/* =========================\n     CONTAINER\n  ========================= */\n\n.register-container {\n  /* min-height: 100vh; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 30px;\n  margin-bottom: 50px;\n}\n\n.register-logo {\n  /* display: block;\n    margin: 0 auto;\n    margin-top: 30px; */\n}\n\n/* =========================\n     CARD\n  ========================= */\n\n.register-card {\n  width: 100%;\n  max-width: 600px;\n  background-color: #1e293b;\n  border-radius: 20px;\n  padding: 30px 28px 35px;\n  box-shadow: 0 10px 40px -20px rgba(0, 0, 0, 0.65);\n  border: 1px solid rgba(148, 163, 184, 0.12);\n}\n\n/* =========================\n     TITLES\n  ========================= */\n\n.register-step animate h2 {\n  font-size: 1.4rem;\n  font-weight: 700;\n  margin-bottom: 15px;\n  text-align: center;\n  letter-spacing: 0.3px;\n}\n\n\n.flexed_logo_title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.register-step h2 {\n  font-size: 20px;\n}\n\n/* =========================\n     PROGRESS BAR\n  ========================= */\n\n.register-progress {\n  width: 100%;\n  height: 6px;\n  background: #1e293b;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 25px;\n}\n\n.register-progress-bar {\n  height: 100%;\n  width: 0;\n  background: linear-gradient(90deg, #38bdf8, #22c55e);\n  transition: width 0.4s ease;\n}\n\n/* =========================\n     STEP ANIMATION\n  ========================= */\n\n.register-step {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.register-animate {\n  animation: slideFade 0.45s ease;\n}\n\n@keyframes slideFade {\n  from {\n    opacity: 0;\n    transform: translateX(35px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* =========================\n     PROFILE GRID\n  ========================= */\n\n.register-profile-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px;\n}\n\n.register-profile-grid button {\n  padding: 14px 12px;\n  border-radius: 14px;\n  background: transparent;\n  border: 1px solid #334155;\n  color: #e5e7eb;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n.register-profile-grid button:hover {\n  border-color: #38bdf8;\n  background: rgba(56, 189, 248, 0.08);\n}\n\n.register-profile-grid button.active {\n  /* background: linear-gradient(135deg, var(--bg-200), var(--bg-300) ); */\n  background-color: var(--primary-100);\n  color: #020617;\n  font-weight: 700;\n  border-color: transparent;\n}\n\n/* =========================\n     FORM GRID\n  ========================= */\n\n.register-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n/* =========================\n     INPUTS & SELECTS\n  ========================= */\n\n\n.register-inputs[type=\"date\"] {\n  width: 100%;\n  height: 50px;\n  min-height: 50px;\n  font-size: 16px;\n  padding: 0 12px;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.register-inputs,\n.register-select {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid #334155;\n  background: #020617;\n  color: #f8fafc;\n  font-size: 16px;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.register-inputs::placeholder {\n  color: #94a3b8;\n}\n\n.register-select {\n  cursor: pointer;\n}\n\n.register-inputs:focus,\n.register-select:focus {\n  outline: none;\n  border-color: #38bdf8;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25);\n}\n\n/* full width for single inputs if needed */\n.form-grid>*:only-child {\n  grid-column: span 2;\n}\n\n/* =========================\n     ACTION BUTTONS\n  ========================= */\n\n.register-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  gap: 12px;\n}\n\n.register-primary-btn {\n  padding: 12px 22px;\n  border-radius: 14px;\n  /* background: linear-gradient(135deg, var(--primary-100), var(--primary-200) ); */\n  background-color: var(--primary-200);\n  border: none;\n  font-weight: 700;\n  color: var(--primary-300);\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.register-primary-btn:hover {\n  /* transform: translateY(-1px); */\n  background-color: #6c95b7;\n  transition: 0.3s;\n  /* box-shadow: 6px -6px 50px -10px var(--accent-100); */\n}\n\n.register-primary-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.register-secondary-btn {\n  padding: 12px 22px;\n  border-radius: 14px;\n  background: transparent;\n  border: 1px solid #334155;\n  color: #e5e7eb;\n  cursor: pointer;\n  transition: background 0.25s ease, border-color 0.25s ease;\n}\n\n.register-secondary-btn:hover {\n  background: rgba(148, 163, 184, 0.1);\n  border-color: #38bdf8;\n}\n\n.register-step a {\n  color: var(--primary-100);\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n}\n\n/* =========================\n     RESPONSIVE\n  ========================= */\n\n@media (max-width: 520px) {\n  .register-card {\n    padding: 24px 20px;\n  }\n\n  .register-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .register-profile-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .register-actions {\n    flex-direction: column-reverse;\n  }\n\n  .register-primary-btn,\n  .register-secondary-btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n\n.register-step h2 {\n  color: var(--primary-300);\n}\n\n\n.register-topbar {\n  width: 100%;\n  max-width: 520px;\n  /* même largeur que la carte */\n  margin: 40px auto 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* logo */\n.register-logo {\n  /* width:160px; */\n}\n\n/* back button */\n.register-back-home {\n  font-size: 14px;\n  color: #1c7ab4;\n  text-decoration: none;\n  display: flex;\n  /* align-items:center; */\n  /* gap:6px; */\n  font-weight: 500;\n  transition: .3s;\n  margin-top: 40px;\n}\n\n.register-back-home:hover {\n  color: #f35a0e;\n  transform: translateX(-3px);\n}\n\n\n@media (max-width: 600px) {\n\n  .register-topbar {\n    max-width: 80%;\n    padding: 0 20px;\n    margin: 20px auto 10px;\n  }\n\n  .register-logo {\n    width: 120px;\n  }\n\n  .register-back-home {\n    font-size: 13px;\n  }\n}\n\n\n.loading-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  margin: 6px 0 10px;\n  padding: 8px 12px;\n\n  font-size: 0.85rem;\n  font-weight: 500;\n\n  color: #475569;\n  /* slate-600 */\n  background-color: #f8fafc;\n  /* slate-50 */\n  border-left: 3px solid var(--primary-100);\n  /* blue-500 */\n\n  border-radius: 6px;\n}\n\n\n.pdf-upload-label {\n  height: 55px;\n  border: 2px dashed var(--primary-200);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #fff;\n  font-weight: 600;\n  transition: .25s;\n}\n\n.pdf-upload-label:hover {\n  background: var(--bg-100);\n  color: #020617;\n}\n\n.pdf-selected {\n  margin-top: 8px;\n  font-size: 13px;\n  color: var(--primary-200);\n  font-weight: 600;\n}\n\n\n\n.register-question {\n  color: white;\n  font-size: 16px;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.register-choice-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.choice-btn {\n  border: none;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  background: #1b2f46;\n  color: white;\n  transition: .25s;\n}\n\n.choice-btn.active {\n  background: var(--primary-100);\n  transform: scale(1.04);\n}\n\n\n\n.verification-info-card {\n  background: rgba(255, 255, 255, .06);\n  border: 1px solid rgba(255, 255, 255, .12);\n  border-radius: 18px;\n  padding: 22px;\n  margin-bottom: 25px;\n  color: white;\n  backdrop-filter: blur(14px);\n}\n\n.verification-badge {\n  display: inline-block;\n  background: rgba(34, 197, 94, .18);\n  color: #22c55e;\n  padding: 6px 12px;\n  border-radius: 30px;\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 14px;\n}\n\n.verification-info-card h3 {\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.verification-info-card p {\n  color: #cbd5e1;\n  line-height: 1.6;\n}\n\n.verification-privacy {\n  margin-top: 10px;\n  color: #94a3b8;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n\n.verification-wrapper {\n  width: 100%;\n}\n\n.verification-content {\n  margin-top: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.verification-info-card {\n  width: 100%;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.register-question {\n  width: 100%;\n  display: block;\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 10px;\n}\n\n.register-choice-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 10px;\n}\n\n.verification-privacy {\n  margin-top: 30px;\n}\n\n\n.multi-status-block {\n  grid-column: 1/-1;\n}\n\n.multi-status-title {\n  display: block;\n  margin-bottom: 16px;\n  color: white;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.status-chip-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.status-chip {\n  border: none;\n  cursor: pointer;\n  padding: 12px 18px;\n  border-radius: 999px;\n  background: #0f172a;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, .1);\n  transition: .2s;\n}\n\n.status-chip:hover {\n  transform: translateY(-2px);\n}\n\n.status-chip.active {\n  background: var(--primary-200);\n  color: white;\n}\n\n.status-chip:disabled {\n  opacity: .35;\n  cursor: not-allowed;\n}\n\n\n.input-success {\n  border: 1px solid #00c853;\n}\n\n.password-rules {\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.ok {\n  color: #00c853;\n}\n\n.bad {\n  color: #ff3b30;\n}\n\n\n/* sszdsz.. */\n.password-strength-bar {\n  width: 100%;\n  height: 6px;\n  background: #eee;\n  border-radius: 50px;\n  margin-top: 8px;\n  overflow: hidden;\n}\n\n.password-strength-bar span {\n  display: block;\n  height: 100%;\n  transition: .3s;\n}\n\n.weak {\n  background: #ff3b30;\n}\n\n.medium {\n  background: #ff9500;\n}\n\n.strong {\n  background: #00c853;\n}\n\n.password-message {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #d0d0d0;\n}\n\n\n\n/* reset password */\n\n.forgot-modal {\n\n  width: 350px;\n\n  padding: 35px;\n\n  border-radius: 24px;\n\n  background: white;\n\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n\n  gap: 18px;\n\n  animation: fadeUp .35s ease;\n\n}\n\n.forgot-icon {\n\n  width: 70px;\n  height: 70px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  font-size: 32px;\n\n  background:\n    linear-gradient(135deg,\n      #eff6ff,\n      #dbeafe);\n\n  margin-bottom: 5px;\n\n}\n\n.forgot-subtitle {\n\n  font-size: 14px;\n\n  color: #64748b;\n\n  text-align: center;\n\n  line-height: 1.6;\n\n  margin-bottom: 10px;\n\n}\n\n.forgot-input {\n\n  width: 100%;\n\n  padding: 14px 18px;\n\n  border-radius: 14px;\n\n  border:\n    1px solid #e2e8f0;\n\n  outline: none;\n\n  font-size: 14px;\n\n  transition: .3s;\n\n}\n\n.forgot-input:focus {\n\n  border-color: var(--primary-100);\n\n  box-shadow:\n    0 0 0 4px rgba(255, 155, 92, 0.1);\n\n}\n\n.forgot-btn {\n\n  width: 100%;\n\n  padding: 14px;\n\n  border: none;\n\n  border-radius: 14px;\n\n  background: var(--primary-100);\n\n  color: white;\n\n  font-size: 15px;\n\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition: .3s;\n\n}\n\n.forgot-btn:hover {\n\n  transform:\n    translateY(-2px);\n\n}\n\n@keyframes fadeUp {\n\n  from {\n\n    opacity: 0;\n\n    transform:\n      translateY(20px);\n\n  }\n\n  to {\n\n    opacity: 1;\n\n    transform:\n      translateY(0);\n\n  }\n\n}\n\n\n.password-input-container {\n  position: relative;\n  width: 100%;\n}\n\n.password-input-container input {\n  width: 100%;\n  padding-right: 45px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #777;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n}\n\n.password-toggle:hover {\n  color: #333;\n}\n\n/* Register — premium CarrerUp high-tech shell */\n.register-page {\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  min-height: 100svh;\n  justify-content: flex-start;\n  overflow: visible;\n  color: #17344f;\n  background-color: #edf4f8;\n  padding: 18px 20px 42px;\n}\n\n.register-topbar { width: min(1040px, 100%); margin: 0 auto 18px; display: flex; }\n.register-back-home { display: inline-flex; align-items: center; min-height: 42px; padding: 0 16px; border: 1px solid #d6e4ee; border-radius: 12px; background: #fff; color: #4e7799; font-weight: 800; text-decoration: none; box-shadow: 0 8px 22px rgba(41,74,101,.08); }\n.register-container { min-height: auto; margin: 0; padding: 0; align-items: flex-start; }\n.register-card { position: relative; width: min(100%, 900px); max-width: 900px; padding: 34px; overflow: hidden; border: 1px solid #d8e5ed; border-radius: 24px; background: #fff; box-shadow: 0 26px 60px rgba(33,63,88,.14); }\n.register-card::before { content: \"\"; position: absolute; inset: 0 auto 0 0; width: 5px; background: #e95a13; }\n.register-step { position: relative; gap: 18px; }\n.register-step h2 { margin: 2px 0 4px; color: #17344f; font-size: clamp(1.3rem, 2vw, 1.8rem); font-weight: 850; letter-spacing: -.035em; }\n.flexed_logo_title { padding-bottom: 8px; border-bottom: 1px solid #e4edf2; }\n.flexed_logo_title img { width: 44px !important; height: 44px; padding: 7px; object-fit: contain; border: 1px solid #f4c4aa; border-radius: 13px; background: #fff6f1; }\n.register-journey { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin: 0 0 28px; padding: 13px; border: 1px solid #dbe7ee; border-radius: 16px; background: #f7fafc; }\n.register-journey-step { display: flex; align-items: center; gap: 9px; color: #94a9ba; font-weight: 800; }\n.register-journey-step span { display: grid; width: 29px; height: 29px; place-items: center; border: 1px solid #c6d7e2; border-radius: 9px; background: #fff; font-size: .8rem; }\n.register-journey-step small { font-size: .72rem; text-transform: uppercase; letter-spacing: .08em; }\n.register-journey-step.is-active { color: #4e7799; }.register-journey-step.is-active span { border-color: #4e7799; }.register-journey-step.is-current { color: #e95a13; }.register-journey-step.is-current span { border-color: #e95a13; background: #fff4ee; }\n.register-profile-grid { grid-template-columns: repeat(3, 1fr); gap: 12px; }\n.register-profile-grid button { min-height: 84px; padding: 14px; border: 1px solid #d9e6ee; border-radius: 15px; background: #fff; color: #315978; font-weight: 800; box-shadow: none; transition: transform .18s ease, border-color .18s ease, background .18s ease; }\n.register-profile-grid button:hover { transform: translateY(-2px); border-color: #94a9ba; }.register-profile-grid button.active { border-color: #e95a13; background: #fff5f0; color: #c74608; box-shadow: inset 0 0 0 1px #e95a13; }\n.register-form-grid { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 14px; }.register-form-grid .full-width, .register-form-grid .status-container, .register-form-grid .loading-hint { grid-column: 1 / -1; }\n.register-inputs, .register-select { box-sizing: border-box; width: 100%; min-height: 48px; padding: 0 14px; border: 1px solid #d4e2eb; border-radius: 12px; background: #fbfdfe; color: #17344f; outline: none; box-shadow: none; }\n.register-inputs:focus, .register-select:focus { border-color: #4e7799; background: #fff; box-shadow: 0 0 0 3px rgba(78,119,153,.12); }.register-inputs::placeholder { color: #94a9ba; }\n.register-actions { display: grid; grid-template-columns: 1fr 1.35fr; gap: 12px; margin-top: 8px; }.register-primary-btn, .register-secondary-btn { min-height: 48px; border-radius: 12px; font-weight: 850; }.register-primary-btn { border: 1px solid #e95a13; background: #e95a13; color: #fff; box-shadow: 0 9px 18px rgba(233,90,19,.2); }.register-secondary-btn { border: 1px solid #d2e0e9; background: #fff; color: #4e7799; }\n.verification-wrapper { display: grid; gap: 14px; }.verification-info-card, .verification-content, .verification-privacy { border: 1px solid #dbe7ee; border-radius: 16px; background: #f8fbfd; }.verification-info-card { padding: 19px; }.verification-info-card h3 { margin: 9px 0 5px; color: #17344f; }.verification-info-card p, .verification-privacy { color: #66839a; }.verification-content { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; padding: 14px; }.pdf-upload-label { display:flex; align-items:center; min-height: 58px; padding: 12px 14px; border: 1px dashed #94a9ba; border-radius: 12px; background:#fff; color:#315978; font-weight:800; cursor:pointer; }.pdf-upload-label:hover { border-color:#e95a13; color:#e95a13; }.pdf-selected { margin-top: 7px; color:#4e7799; font-size:.82rem; font-weight:700; }.verification-privacy { padding: 13px 16px; font-size: .84rem; }\n@media (max-width: 640px) { .register-page { padding: 12px 12px 28px; }.register-topbar { margin-bottom: 12px; }.register-card { padding: 22px 17px; border-radius: 18px; }.register-journey { padding: 10px; gap: 5px; }.register-journey-step { justify-content:center; }.register-journey-step small { display:none; }.register-profile-grid, .register-form-grid, .verification-content { grid-template-columns: 1fr; }.register-profile-grid button { min-height: 58px; }.register-actions { grid-template-columns: 1fr; }.register-actions .register-secondary-btn { order: 2; }.register-step > a { text-align:center; }.flexed_logo_title { gap: 8px; } }\n\n/* Registration mobile experience */\n.register-card { animation: registerCardArrive .56s cubic-bezier(.2,.9,.25,1) both; }\n.register-animate { animation: registerStepReveal .42s cubic-bezier(.2,.9,.25,1) both; }\n.register-journey-step.is-current span { animation: registerStepPulse 1.8s ease-in-out infinite; }\n.register-profile-grid button { animation: registerOptionReveal .38s ease both; }\n.register-profile-grid button:nth-child(2) { animation-delay:.04s; }.register-profile-grid button:nth-child(3) { animation-delay:.08s; }.register-profile-grid button:nth-child(4) { animation-delay:.12s; }.register-profile-grid button:nth-child(5) { animation-delay:.16s; }.register-profile-grid button:nth-child(6) { animation-delay:.20s; }.register-profile-grid button:nth-child(7) { animation-delay:.24s; }\n.register-primary-btn:not(:disabled):active, .register-secondary-btn:active { transform:scale(.98); }\n@keyframes registerCardArrive { from { opacity:0; transform:translateY(22px) scale(.985); } to { opacity:1; transform:translateY(0) scale(1); } }\n@keyframes registerStepReveal { from { opacity:0; transform:translateX(18px); } to { opacity:1; transform:translateX(0); } }\n@keyframes registerOptionReveal { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }\n@keyframes registerStepPulse { 0%,100% { box-shadow:0 0 0 0 rgba(233,90,19,.22); } 50% { box-shadow:0 0 0 7px rgba(233,90,19,0); } }\n\n@media (max-width: 640px) {\n  .register-page { min-height:100svh; padding:10px 10px 22px; }\n  .register-topbar { position:relative; top:auto; z-index:auto; max-width:100%; padding:0; margin:0 0 10px; }.register-back-home { min-height:38px; margin:0; padding:0 13px; border-radius:11px; font-size:.79rem; }\n  .register-card { width:100%; padding:18px 14px 20px; border-radius:17px; box-shadow:0 16px 34px rgba(33,63,88,.13); }.register-card::before { width:3px; }\n  .register-journey { margin-bottom:18px; padding:8px; border-radius:13px; }.register-journey-step span { width:27px; height:27px; border-radius:8px; }\n  .register-step { gap:14px; }.register-step h2 { font-size:1.28rem; line-height:1.16; }.flexed_logo_title { padding-bottom:10px; }.flexed_logo_title img { width:39px !important; height:39px; border-radius:11px; }\n  .register-profile-grid { grid-template-columns:repeat(2,minmax(0,1fr)); gap:9px; }.register-profile-grid button { min-height:70px; padding:10px 7px; border-radius:13px; font-size:.79rem; line-height:1.15; }.register-profile-grid button:last-child:nth-child(odd) { grid-column:1 / -1; }\n  .register-form-grid { gap:11px; }.register-inputs, .register-select { min-height:52px; padding:0 13px; border-radius:11px; font-size:16px; }.input-wrapper { gap:3px; }.password-strength-bar { margin-top:4px; }.password-message { margin-top:3px; line-height:1.35; }\n  .register-actions { position:sticky; bottom:8px; z-index:3; gap:8px; margin:8px -2px -2px; padding:10px 2px 2px; background:#fff; }.register-primary-btn, .register-secondary-btn { min-height:51px; border-radius:12px; }\n  .verification-info-card { padding:15px; border-radius:14px; }.verification-info-card h3 { font-size:1rem; }.verification-info-card p { font-size:.82rem; line-height:1.5; }.verification-content { padding:10px; gap:9px; border-radius:14px; }.pdf-upload-label { min-height:54px; padding:10px 12px; font-size:.82rem; }.verification-privacy { padding:11px 13px; font-size:.76rem; }\n}\n\n@media (max-width: 360px) { .register-page { padding:8px; }.register-card { padding:16px 11px; }.register-profile-grid { gap:7px; }.register-profile-grid button { min-height:63px; font-size:.73rem; }.register-step h2 { font-size:1.16rem; }.register-journey { margin-bottom:14px; }.register-actions { bottom:4px; } }\n@media (prefers-reduced-motion: reduce) { .register-card, .register-animate, .register-profile-grid button, .register-journey-step.is-current span, .verification-upload-alert, .verification-upload-alert > span, .verification-upload-error .pdf-upload-label, .verification-upload-error .pdf-upload-label::before { animation:none; } }\n\n@media (max-width: 640px) {\n  .register-step--form { gap:11px; }.register-step--form h2 { margin:0 2px 1px; font-size:1.2rem; }.register-step--form .register-form-grid { position:relative; max-height:min(48svh, 440px); overflow-y:auto; overscroll-behavior:contain; padding:10px; border:1px solid #dbe8ef; border-radius:16px; background:#f7fafc; gap:7px; box-shadow:inset 0 1px 0 #fff; scrollbar-width:thin; scrollbar-color:#94a9ba transparent; }.register-step--form .register-form-grid::-webkit-scrollbar { width:5px; }.register-step--form .register-form-grid::-webkit-scrollbar-thumb { border-radius:999px; background:#94a9ba; }.register-step--form .register-form-grid::before { content:\"INFORMATIONS DU PROFIL\"; grid-column:1 / -1; margin:0 2px 3px; color:#4e7799; font-size:.62rem; font-weight:900; letter-spacing:.13em; }\n  .register-step--form .register-actions { position:relative; bottom:auto; margin:2px 0 0; padding:0; background:transparent; }.register-step--form .register-inputs, .register-step--form .register-select { min-height:43px; padding:0 11px; border-radius:10px; background:#fff; border-color:#d7e5ed; font-size:.85rem; }.register-step--form .input-wrapper:focus-within { transform:translateY(-1px); transition:transform .18s ease; }\n.register-step--form .error-message { padding:4px 7px; border:1px solid #f2c7bd; border-radius:7px; background:#fff6f3; font-size:.68rem; }.register-step--form .loading-hint { padding:8px 10px; border:1px solid #d8e6ee; border-radius:9px; background:#f7fbfd; color:#4e7799; font-size:.75rem; font-weight:750; }\n.register-date-label { display:block;margin:0 0 6px 3px;color:#4e7799;font-size:.72rem;font-weight:850;letter-spacing:.02em; }\n.register-date-label::before { content:\"\";display:inline-block;width:5px;height:5px;margin-right:7px;border-radius:50%;background:#e95a13;box-shadow:0 0 7px rgba(233,90,19,.5);vertical-align:middle; }\n  .register-step--verification { gap:9px; }\n  .register-step--verification h2 { margin:0; padding:0 3px; }\n  .register-step--verification .verification-wrapper {\n    max-height:none;\n    overflow:visible;\n    padding:0;\n    gap:8px;\n  }\n  .register-step--verification .verification-content { order:1; }\n  .register-step--verification .verification-info-card { order:2; }\n  .register-step--verification .verification-privacy { order:3; }\n  .register-step--verification .verification-info-card {\n    display:flex;\n    flex-direction:column;\n    align-items:flex-start;\n    gap:5px;\n    padding:12px 13px;\n    border-color:#d5e3eb;\n    background:linear-gradient(145deg,#fff,#f7fafc);\n    box-shadow:0 7px 18px rgba(31,67,94,.055);\n  }\n  .register-step--verification .verification-badge { display:inline-flex; align-items:center; width:auto; max-width:100%; padding:5px 8px; border:1px solid #f0c0a5; border-radius:8px; background:#fff5f0; color:#ca4c0a; font-size:.64rem; font-weight:850; line-height:1.2; }\n  .register-step--verification .verification-info-card h3 { margin:1px 0 0; font-size:.94rem; line-height:1.22; }\n  .register-step--verification .verification-info-card p { margin:0; color:#66839a; font-size:.75rem; line-height:1.42; }\n  .register-step--verification .verification-content { position:relative; overflow:visible; padding:11px; gap:8px; border-color:#d5e3eb; background:#f8fbfd; }.register-step--verification .verification-content::before { content:\"DOCUMENTS REQUIS\"; display:block; grid-column:1 / -1; margin:0 2px 2px; color:#4e7799; font-size:.61rem; font-weight:900; letter-spacing:.12em; }\n  .register-step--verification .pdf-upload-label { position:relative; justify-content:flex-start; min-height:52px; padding:9px 11px 9px 42px; border-color:#aac0cf; line-height:1.3; }.register-step--verification .pdf-upload-label::before { content:\"+\"; position:absolute; left:12px; display:grid; width:22px; height:22px; place-items:center; border:1px solid #f0b18c; border-radius:7px; background:#fff4ee; color:#e95a13; font-size:1rem; line-height:1; }\n.register-step--verification .pdf-selected { padding:7px 9px; border:1px solid #d8e7ee; border-radius:8px; background:#fff; font-size:.74rem; overflow-wrap:anywhere; }.register-step--verification .register-question { color:#315978; font-size:.88rem; font-weight:800; }.register-step--verification .register-choice-row { display:grid; grid-template-columns:1fr 1fr; gap:8px; }.register-step--verification .choice-btn { min-height:46px; border-radius:11px; }\n.register-step--verification .verification-privacy { margin:0; padding:9px 11px; border-color:#d8e5ed; background:#f8fbfd; font-size:.72rem; line-height:1.4; }\n.register-step--verification .register-actions { position:relative; bottom:auto; grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr); gap:7px; margin:1px 0 0; padding:0; background:transparent; }\n.register-step--verification .register-actions .register-secondary-btn { order:initial; }\n.register-step--verification .register-primary-btn, .register-step--verification .register-secondary-btn { min-height:47px; padding:7px 8px; font-size:.78rem; }\n.register-step--verification .register-primary-btn { box-shadow:0 9px 18px rgba(233,90,19,.22); }\n\n.verification-upload-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 2px 0;\n  padding: 12px 14px;\n  border: 1px solid #ef9c72;\n  border-radius: 12px;\n  color: #8f340c;\n  background: #fff3ed;\n  box-shadow: 0 10px 24px rgba(233, 90, 19, .12);\n  animation: verificationAlertIn .38s cubic-bezier(.2, .9, .25, 1) both;\n}\n.verification-upload-alert > span {\n  display: grid;\n  flex: 0 0 25px;\n  width: 25px;\n  height: 25px;\n  place-items: center;\n  border-radius: 8px;\n  color: #fff;\n  background: #e95a13;\n  font-weight: 900;\n  animation: verificationAlertPulse 1.15s ease-in-out 2;\n}\n.verification-upload-alert strong { display: block; font-size: .82rem; }\n.verification-upload-alert p { margin: 3px 0 0; font-size: .74rem; line-height: 1.4; }\n.verification-upload-error .pdf-upload-label {\n  border-color: #e95a13;\n  color: #c74608;\n  background: #fff8f4;\n  animation: verificationUploadShake .48s cubic-bezier(.36, .07, .19, .97) both;\n}\n.verification-upload-error .pdf-upload-label::before {\n  color: #fff;\n  background: #e95a13;\n  box-shadow: 0 0 0 5px rgba(233, 90, 19, .11);\n  animation: verificationUploadPulse 1.2s ease-in-out infinite;\n}\n@media (min-width: 641px) {\n  .verification-upload-alert {\n    gap: 14px;\n    padding: 15px 17px;\n    border-radius: 14px;\n    box-shadow: 0 14px 32px rgba(233, 90, 19, .14);\n  }\n  .verification-upload-alert > span {\n    flex-basis: 30px;\n    width: 30px;\n    height: 30px;\n    border-radius: 9px;\n    font-size: 1rem;\n  }\n  .verification-upload-alert strong { font-size: .92rem; }\n  .verification-upload-alert p { margin-top: 4px; font-size: .82rem; }\n  .verification-upload-error .verification-content {\n    border-color: rgba(233, 90, 19, .48);\n    background: #fffaf7;\n    box-shadow: 0 0 0 3px rgba(233, 90, 19, .07);\n    transition: border-color .2s ease, background .2s ease, box-shadow .2s ease;\n  }\n}\n@keyframes verificationAlertIn {\n  from { opacity: 0; transform: translateY(-8px) scale(.98); }\n  to { opacity: 1; transform: none; }\n}\n@keyframes verificationAlertPulse { 50% { transform: scale(1.12); box-shadow: 0 0 0 7px rgba(233,90,19,.12); } }\n@keyframes verificationUploadPulse { 50% { transform: scale(1.1); box-shadow: 0 0 0 8px rgba(233,90,19,.05); } }\n@keyframes verificationUploadShake {\n  20%, 60% { transform: translateX(-5px); }\n  40%, 80% { transform: translateX(5px); }\n}\n}\n\n@media (min-width: 430px) and (max-width: 640px) {\n  .register-step--form .register-form-grid { grid-template-columns:repeat(2, minmax(0, 1fr)); gap:9px; padding:12px; }.register-step--form .register-form-grid .full-width, .register-step--form .register-form-grid .status-container, .register-step--form .register-form-grid .loading-hint { grid-column:1 / -1; }.register-step--form .register-actions { grid-template-columns:1fr 1.35fr; }.register-step--form .register-actions .register-secondary-btn { order:initial; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
